import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export default function ConversationMessageAddressField({ address }) {
  return <div className={classnames('conversationMessageComposer-address')}>{address}</div>;
}

ConversationMessageAddressField.propTypes = {
  address: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/conversation_message_address_field.jsx